// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.circle-graph {
  --rate: 0;
  --radius: 0;
  --thickness: 0;
  --diameter: calc((var(--radius, 0) * 2) + (var(--thickness, 0) * 2));
  --inner-diameter: calc(var(--radius, 0) * 2);
  --circumference: calc(var(--inner-diameter) * 3.141592);
  --meter-color: var(--primary-color-main);
  --meter-base-color: var(--input-bg-color);
}
.circle-graph.disabled {
  --meter-color: var(--disabled-bg-color);
  --meter-base-color: var(--disabled-border-color);
}
.circle-graph .percent {
  position: relative;
  width: calc((var(--diameter)) * 1px);
  height: calc(var(--diameter) * 1px);
}
.circle-graph .percent svg {
  display: block;
  width: calc(var(--diameter) * 1px);
  height: calc(var(--diameter) * 1px);
  transform: rotate(-90deg);
}
.circle-graph .percent svg circle {
  display: block;
  fill: none;
  stroke-width: calc((var(--thickness) + 0) * 2 * 1px);
  stroke: var(--meter-base-color);
  stroke-dasharray: calc(var(--circumference) * 1px);
  stroke-dashoffset: 0;
  stroke-linecap: round;
}
.circle-graph .percent .line {
  animation: circleAnim 1s forwards;
  transition: stroke-dashoffset 1s;
  stroke-dashoffset: calc((var(--circumference) - var(--circumference) * var(--rate) / 100) * 1px);
  stroke: var(--meter-color);
}
@keyframes circleAnim {
  0% {
    stroke-dasharray: calc((var(--circumference) - var(--circumference) * var(--rate) / 100) * 1px) calc(var(--circumference) * 1px);
  }
  99.9%, to {
    stroke-dasharray: calc(var(--circumference) * 1px) calc(var(--circumference) * 1px);
  }
}`, "",{"version":3,"sources":["webpack://./src/_core/components/common/UI/CircleGraph.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,WAAA;EACA,cAAA;EACA,oEAAA;EACA,4CAAA;EACA,uDAAA;EACA,wCAAA;EACA,yCAAA;AACF;AACE;EACE,uCAAA;EACA,gDAAA;AACJ;AAEE;EACE,kBAAA;EACA,oCAAA;EACA,mCAAA;AAAJ;AAEI;EACE,cAAA;EACA,kCAAA;EACA,mCAAA;EAEQ,yBAAA;AAAd;AAEM;EACE,cAAA;EACA,UAAA;EACA,oDAAA;EACA,+BAAA;EACA,kDAAA;EACA,oBAAA;EACA,qBAAA;AAAR;AAII;EACE,iCAAA;EACA,gCAAA;EACA,gGAAA;EACA,0BAAA;AAFN;AAME;EACE;IACE,gIAAA;EAJJ;EAME;IACE,mFAAA;EAJJ;AACF","sourcesContent":[".circle-graph {\r\n  --rate: 0;\r\n  --radius: 0;\r\n  --thickness: 0;\r\n  --diameter: calc((var(--radius, 0) * 2) + (var(--thickness, 0) * 2));\r\n  --inner-diameter: calc(var(--radius, 0) * 2);\r\n  --circumference: calc(var(--inner-diameter) * 3.141592);\r\n  --meter-color: var(--primary-color-main);\r\n  --meter-base-color: var(--input-bg-color);\r\n\r\n  &.disabled{\r\n    --meter-color: var(--disabled-bg-color);\r\n    --meter-base-color: var(--disabled-border-color);\r\n  }\r\n\r\n  .percent {\r\n    position: relative;\r\n    width: calc((var(--diameter)) * 1px);\r\n    height: calc(var(--diameter) * 1px);\r\n\r\n    svg {\r\n      display: block;\r\n      width: calc(var(--diameter) * 1px);\r\n      height: calc(var(--diameter) * 1px);\r\n      -webkit-transform: rotate(-90deg);\r\n              transform: rotate(-90deg);\r\n\r\n      circle {\r\n        display: block;\r\n        fill: none;\r\n        stroke-width: calc(((var(--thickness) + 0) * 2 ) * 1px);\r\n        stroke: var(--meter-base-color);\r\n        stroke-dasharray: calc(var(--circumference) * 1px);\r\n        stroke-dashoffset: 0;\r\n        stroke-linecap: round;\r\n      }\r\n    }\r\n\r\n    .line {\r\n      animation: circleAnim 1s forwards;\r\n      transition: stroke-dashoffset 1s;\r\n      stroke-dashoffset: calc((var(--circumference) - (var(--circumference) * var(--rate)) / 100)  * 1px);\r\n      stroke: var(--meter-color);\r\n    }\r\n  }\r\n  \r\n  @keyframes circleAnim {\r\n    0% {\r\n      stroke-dasharray: calc((var(--circumference) - (var(--circumference) * var(--rate)) / 100)  * 1px) calc(var(--circumference) * 1px);\r\n    }\r\n    99.9%, to {\r\n      stroke-dasharray: calc(var(--circumference) * 1px) calc(var(--circumference) * 1px);\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
